import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const AccessSuccessChart = ({ data, isLoading }) => {
  const COLORS = {
    success: '#10B981', // emerald-500
    failed: '#EF4444',  // red-500
    denied: '#F59E0B'   // amber-500
  };

  const chartData = [
    { name: 'Successful Access', value: data?.successful, color: COLORS?.success },
    { name: 'Failed Attempts', value: data?.failed, color: COLORS?.failed },
    { name: 'Access Denied', value: data?.denied, color: COLORS?.denied }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      const data = payload?.[0];
      return (
        <div className="bg-card border border-border rounded-lg p-3 security-shadow-card">
          <p className="text-sm font-medium text-foreground">{data?.name}</p>
          <p className="text-lg font-bold" style={{ color: data?.payload?.color }}>
            {data?.value?.toLocaleString()}
          </p>
          <p className="text-xs text-muted-foreground">
            {((data?.value / (data?.payload?.payload?.successful + data?.payload?.payload?.failed + data?.payload?.payload?.denied)) * 100)?.toFixed(1)}%
          </p>
        </div>
      );
    }
    return null;
  };

  const CustomLegend = ({ payload }) => {
    return (
      <div className="flex flex-wrap justify-center gap-4 mt-4">
        {payload?.map((entry, index) => (
          <div key={index} className="flex items-center space-x-2">
            <div 
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: entry?.color }}
            />
            <span className="text-sm text-foreground">{entry?.value}</span>
          </div>
        ))}
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 security-shadow-card">
        <div className="flex items-center justify-center h-80">
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-primary rounded-full animate-pulse" />
            <span className="text-muted-foreground">Loading chart data...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 security-shadow-card">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-foreground">Access Success Rate</h3>
        <p className="text-sm text-muted-foreground">Distribution of access attempts by outcome</p>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={120}
              paddingAngle={2}
              dataKey="value"
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AccessSuccessChart;